import { render, staticRenderFns } from "./PreviewDetails.vue?vue&type=template&id=060c677a"
import script from "./PreviewDetails.vue?vue&type=script&lang=js"
export * from "./PreviewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports